import React from 'react';
import { NavLink } from 'react-router-dom';

function AdminSidebar() {
  return (
    <div className="col-md-3 left_col">
      <div className="left_col scroll-view">
        <div className="navbar nav_title" style={{border: 0}}>
          <NavLink to="/admin/dashboard" className="site_title">
            <img src="img/logo.svg" alt="Logo" />
          </NavLink>
        </div>
        <div className="clearfix" />
        {/* sidebar menu */}
        <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
          <div className="menu_section">
            <ul className="nav side-menu">
              <li>
                <NavLink 
                  to="/admin/dashboard" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-home" /> Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/usermanager" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-user-circle-o" /> User Manager
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/about" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> About-Us
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/privacy-policy" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/term-and-condition" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Terms &amp; Condition
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/cancle-policy" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Cancellation &amp; Refund
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/day" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Add Day
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/percentage" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Index &amp; Stock %
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/video" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Video
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/hotchart" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Hot Chart
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/plan" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-rupee" /> Plans
                </NavLink>
              </li>
                <li>
                <NavLink 
                  to="/admin/webhook" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-file-text" /> Webhook URL
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/profile" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-user-circle-o" /> Profile
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/contact" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-phone" /> Contact Us
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/subscription" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-list-alt" /> Subscription list
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/notification" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-bell-o" /> Notification
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/landingPage" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  <i className="fa fa-film" /> Landing Page
                </NavLink>
              </li>
              <li>
                <NavLink  to="/admin/blog-list"  className={({ isActive }) => isActive ? 'active' : ''}>
                <i className="fa fa-user-circle-o" /> Blogs</NavLink>
              </li>
              <li>
                <NavLink  to="/admin/stock"  className={({ isActive }) => isActive ? 'active' : ''}>
                <i className="fa fa-user-circle-o" /> Tranding Stock</NavLink>
              </li>
              <li>
                <a href="setting.html"><i className="fa fa-gear" /> Setting</a>
              </li>
            </ul>
          </div>
        </div>
        {/* /sidebar menu */}
      </div>
    </div>
  );
}

export default AdminSidebar;
